import { render } from "./wishlist-add-success-modal.vue?vue&type=template&id=78627f37"
import script from "./wishlist-add-success-modal.vue?vue&type=script&lang=js"
export * from "./wishlist-add-success-modal.vue?vue&type=script&lang=js"

import "./wishlist-add-success-modal.vue?vue&type=style&index=0&id=78627f37&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__